import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import { THEME } from 'frontend-utils/utils/prism/theme';
import type { Transition } from 'lumen/services/transition';

export default class HotelSettingsThemeRoute extends Route {
  @service declare theme: Services['theme'];
  @service declare transition: Services['transition'];

  // eslint-disable-next-line @typescript-eslint/require-await
  async afterModel(transition: Transition): Promise<void> {
    if (this.theme.hasPermissions || this.theme.selectedTheme !== THEME.LIGHT) {
      return;
    }

    this.transition.redirectToEnabledTab(transition);
  }
}
